// extracted by mini-css-extract-plugin
export var icon = "_6a-1";
export var subtext = "_6a-0";